// © Microsoft Corporation. All rights reserved.
import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { v1 as createGUID } from 'uuid';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import DateRangeIcon from '@material-ui/icons/DateRange';
import VideocamIcon from '@material-ui/icons/Videocam';
import MaterialUiPhoneNumber from "material-ui-phone-number";
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";
import { AppBar, Tabs, Tab, Box, Button } from '@material-ui/core';
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CancelIcon from '@material-ui/icons/Cancel';
import Check from '@material-ui/icons/Check';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Autocomplete from '@mui/material/Autocomplete';
import TextFields from '@mui/material/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import SettingsApplicationsRoundedIcon from '@material-ui/icons/SettingsApplicationsRounded';
import SettingsIcon from '@material-ui/icons/Settings';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { Carousel } from '@trendyol-js/react-carousel';
import { Spinner } from '@fluentui/react';
// import ColorPicker from 'react-color-picker'
// import 'react-color-picker/index.css'
import {
  localStorageAvailable,
  getDisplayFirstNameFromLocalStorage,
  saveDisplayFirstNameToLocalStorage,
  getDisplayLastNameFromLocalStorage,
  saveDisplayLastNameToLocalStorage,
  getDisplayEmailFromLocalStorage,
  saveDisplayEmailToLocalStorage,
  getDisplayMobileFromLocalStorage,
  saveDisplayMobileToLocalStorage,
  getDisplayIMOFromLocalStorage,
  saveDisplayIMOToLocalStorage,
  getDisplayHEXIDFromLocalStorage,
  saveDisplayHEXIDToLocalStorage,
  getDisplayMMSIFromLocalStorage,
  saveDisplayMMSIToLocalStorage,
  saveDisplayTCToLocalStorage,
  getDisplayTCFromLocalStorage
} from '../Utils/localStorage';

import ship1 from "../ship1.jpg";
import ship2 from "../ship2.jpg";
import ship3 from "../ship3.jpg";
import ship4 from "../ship4.jpg";
import ship5 from "../ship5.jpg";
import ship6 from "../ship6.jpg";
import ship7 from "../ship7.jpg";
import ship8 from "../ship8.jpg";
import ship9 from "../ship9.jpg";
import ship10 from "../ship10.jpg";
import ship11 from "../ship11.jpg";
import ship12 from "../ship12.jpg";
import ship13 from "../ship13.jpg";
import ship14 from "../ship14.jpg";
import ship15 from "../ship15.jpg";
import ship16 from "../ship16.jpg";

import Liberianlogo from "../Liberian-Registry-logo.png";
import topLiberianlogo from "../Liberianlogo.png";


import landingpage from "../login_page.png";
import { createThread, createThreads, isValidThread, createscheduleMeeting, getMeetingInfoData, createMeetingUserDetails, createThreadHelper } from '../core/chatSideEffects';
import { getThreadId } from '../Utils/Utils';
import { timezones } from './TimeZones';
import { State } from '../core/reducers';

const mapDispatchToProps = (dispatch: any) => ({
  isValidThread: async (threadId: string, groupId: string) => dispatch(isValidThread(threadId, groupId))
});

const mapStateToProps = (state: State) => ({
  serverCallId: state.calls.serverCallId,
  createThreadHandler: (groupId: string, threadId: string) => {
    createThread(groupId, threadId, state.calls.serverCallId);
  },
});

export interface HomeScreenProps {
  startCallHandler(threadId: boolean, name: string, status: number, groupId: string): void;
  startCallLoader(loader: boolean): void;
  startCall(loader: boolean): void;
  joinTeamsMeeting(meetingLink: string): void;
  createThreadHandler(groupId: string, threadId: string): void;
  isValidThread(threadId: string | null, groupId: string): any;
  scheduleMeeting(): any;
  lightColor: string;
  darkColor: string;
  homeColor: string;
  setUpAgent(name: string): any;
  rejoin: boolean;
  pageLoader: boolean;
  reCall(): any;
  serverCallId: any;
  meetingData: any;
}
// const useStyles = makeStyles((theme) => ({
//   root: (props) => ({
//     backgroundColor: props.backgroundColor,
//     color: theme.color,
//   }),
// }));
const useStyles = makeStyles((theme) => ({
  // root: {
  //     flexGrow: 1,
  //     backgroundColor: 'red',
  //     '&$selected': {
  //         backgroundColor: 'blue',
  //     }
  // },

  active_tab: (props: any) => ({
    backgroundColor: '#fff',
    color: props.darkColor,
    textTransform: "none",
    fontSize: '18px',
    fontWeight: 'bold',
    fontFamily: 'Segoe UI',
    minWidth: '255px',
  }),

  default_tabStyle: (props: any) => ({
    color: '#fff',
    opacity: 1,
    fontWeight: 'bold',
    textTransform: "none",
    // borderRight: '1px solid #fff',
    fontSize: '18px',
    fontFamily: 'Segoe UI',
    minWidth: '255px',
    background: props.darkColor,
  }),
  field: {
    width: '100%'
  },
  fieldnamepanel1: {
    width: '100%',
    fontSize: '24px',
    fontFamily: 'Segoe UI',
  },
  fieldnamepanel2: {
    width: '83%',
    fontSize: '24px',
    fontFamily: 'Segoe UI',
  },
  labelStyles: (props: any) => ({
    fontSize: '20px', color: `${props.darkColor}`, fontWeight: 400
  }),
  buttonLoginColor: (props: any) => ({
    background: props.darkColor,
    textTransform: "none",
    height: '54px',
    width: '100%',
    fontSize: '22px',
    fontWeight: 400,
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 0%), 0px 2px 2px 0px rgb(0 0 0 / 0%), 0px 1px 5px 0px rgb(0 0 0 / 0%)',
    '&:hover': {
      background: props.lightColor,
    },
  }),

  learnbuttonLoginColor: (props: any) => ({
    width: '160px',
    height: '40px',
    fontSize: '18px',
    // color: props.homeColor,
    // background: '#3c3e3e00',
    // border: `2px solid ${props.homeColor}`,
    background: props.darkColor,
    color: '#fff',
    border: `2px solid  ${props.darkColor}`,
    '&:hover': {
      background: props.darkColor,
      color: '#fff',
      border: `2px solid  ${props.darkColor}`,
    },
  }),



  fristnamepanelm1: {
    height: '85px',
    fontFamily: 'Segoe UI',
  },
  emaifristnamepanelm1: {
    height: '64px',
    fontFamily: 'Segoe UI',
  },
  callbackfristnamepanelm1: {
    height: '64px',
    marginTop: '25px',
    fontFamily: 'Segoe UI',
  },
  agreepanelm1: {
    height: '64px',
    marginTop: '12px',
    fontFamily: 'Segoe UI',
  },
  buttonsagreepanelm1: {
    // marginTop: '12px',
    // marginBottom: '25px'
    // textAlign:'center'
  },
  termslink: (props: any) => ({
    color: props.darkColor,
    textDecoration: 'none',
    // fontWeight: 'bold',

  }),
  errormassagepanel: {
    color: '#D92E30',
    fontSize: '12px',
    textAlign: 'left',
    float: 'left'

  },
  errormassagedevice: {
    color: '#D92E30',
    fontSize: '24px',
    textAlign: 'center'
  },
  Selectdatedpanelm1: {
    color: '#707070',
    width: '100%',
    border: '0px',
    height: ' 37px',
    fontSize: '16px',
    marginTop: '0px',
    borderBottom: '1px solid #ccc'

  },

  Selectlabelnamep1: (props: any) => ({
    color: props.darkColor,
    fontSize: '18px',
    textAlign: 'left',
    width: '100%',
    fontWeight: 500
  }),

  DescriptionSelecttext: {
    color: '#707070',
    width: '100%',
    fontSize: '13px',
    textAlign: 'left',
    marginTop: '12px',
    border: '1px solid #B4BBC0',

  },

  gmttimevalue1: {
    color: '#707070',
    fontSize: '13px',
    textAlign: 'left',
    width: '100%',
    background: '#fff'
  },

  timezoneheader1: {
    marginTop: '14px'
  },
  datetimezoneheader1: {
    marginTop: '14px'
  },
  paneHeaderTextStyle: {
    fontSize: '1.375rem',
    fontWeight: 600,
    // width: '69px',
    float: 'left',
    margin: '9px',
    color: '#fff'
  }

}));
function TabPanel(props: any) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: any) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}
const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"];
var daysArray = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const HomeScreen = (props: HomeScreenProps): JSX.Element => {
  const defaultProps = {
    options: timezones,
    getOptionLabel: (option: any) => option.DisplayName,
  };
  const theme: any = useTheme();
  const [value, setValue] = useState<number>(0);
  const classes = useStyles(props);
  const [meetingType, setMeetingType] = useState<string | undefined>('connectNow');
  const [dateTimeValue, setDateTimeValue] = useState<string | undefined>('');
  const isValidThreadProp = props.isValidThread;
  const groupId: string = createGUID();
  // Get display first name from local storage if available
  const defaultDisplayFirstName = localStorageAvailable ? getDisplayFirstNameFromLocalStorage() : null;
  const [displayFirstName, setDisplayFirstName] = useState<string | undefined>(defaultDisplayFirstName ?? undefined);
  // Get display last name from local storage if available
  const defaultDisplayLastName = localStorageAvailable ? getDisplayLastNameFromLocalStorage() : null;
  const [displayLastName, setDisplayLastName] = useState<string | undefined>(defaultDisplayLastName ?? undefined);
  // Get display email from local storage if available
  const defaultDisplayEmail = localStorageAvailable ? getDisplayEmailFromLocalStorage() : null;
  const [displayEmail, setDisplayEmail] = useState<string | undefined>(defaultDisplayEmail ?? undefined);
  // Get display mobile number from local storage if available
  const defaultDisplayMobile = localStorageAvailable ? getDisplayMobileFromLocalStorage() : null;
  const [displayMobile, setDisplayMobile] = useState<string | undefined>(defaultDisplayMobile ?? undefined);
  // Get display IMO number from local storage if available
  const defaultDisplayIMO = localStorageAvailable ? getDisplayIMOFromLocalStorage() : null;
  const [displayIMO, setDisplayIMO] = useState<string | undefined>(defaultDisplayIMO ?? undefined);
  // Get display HEX ID from local storage if available
  const defaultDisplayHEXID = localStorageAvailable ? getDisplayHEXIDFromLocalStorage() : null;
  const [displayHEXID, setDisplayHEXID] = useState<string | undefined>(defaultDisplayHEXID ?? undefined);
  // Get display MMSI from local storage if available
  const defaultDisplayMMSI = localStorageAvailable ? getDisplayMMSIFromLocalStorage() : null;
  const [displayMMSI, setDisplayMMSI] = useState<string | undefined>(defaultDisplayMMSI ?? undefined);
  // Get display tc from local storage if available
  const defaultDisplayTC = localStorageAvailable ? ((getDisplayTCFromLocalStorage() ? (getDisplayTCFromLocalStorage() === 'false' ? false : true) : false)) : false;
  const [termsandConditions, setTermsandConditions] = useState<boolean | undefined>(defaultDisplayTC);

  const [errorDTMsg, setDTErrorMsg] = useState<string | undefined>('');
  const [errorTZMsg, setTZErrorMsg] = useState<string | undefined>('');

  const [errorFNMsg, setFNErrorMsg] = useState<string | undefined>('');
  const [errorLNMsg, setLNErrorMsg] = useState<string | undefined>('');
  const [errorEmailMsg, setEmailErrorMsg] = useState<string | undefined>('');
  const [errorMobileMsg, setMobileErrorMsg] = useState<string | undefined>('');
  const [erroOptMsg, setOpErrorMsg] = useState<string | undefined>('');
  const [errorTCMsg, setTCErrorMsg] = React.useState('');
  const [recordingAgree, setRecordingAgree] = useState<boolean | undefined>(true);
  const [timezone, setTimeZone] = React.useState('Eastern Standard Time');
  const [timezonevalue, setTimeZoneValue] = React.useState({ DaylightName: "Eastern Daylight Time", DisplayName: "(UTC-05:00) Eastern Time (US & Canada)", Id: "Eastern Standard Time", StandardName: "Eastern Standard Time" });
  const [description, setDescription] = React.useState('');
  const [darkColor, setDarkColor] = useState('red');
  const [settingBox, setSettingBox] = useState(false);
  const [scheduleStatus, setScheduleStatus] = useState(false);
  const [thankStatus, setThankStatus] = useState(false);
  const [dutyOfficerDetails, setDutyOfficerDetails] = React.useState({ displayName: '', jobTitle: '', imageByte: '', dutyOfficerEmail: '' });
  const [loader, setLoader] = useState(true);
  const [cameraEnabled, setCameraEnabled] = useState<string | undefined>();
  const [microphoneEnabled, setMicrophoneEnabled] = useState<string | undefined>();

  // const buttonEnabled = displayFirstName && displayLastName && displayEmail && (displayMobile && displayMobile.length === 10) && !errorFNMsg && !errorLNMsg && !errorEmailMsg && !errorMobileMsg && termsandConditions && recordingAgree;
  // const [isValidThread, setIsValidThread] = useState<boolean>(false);
  // useEffect(() => {
  //   const isValidThread = async () => {
  //     if (await isValidThreadProp(getThreadId())) {
  //       setIsValidThread(true);
  //     } else {
  //       setIsValidThread(false);
  //     }
  //   };
  //   isValidThread();
  // }, [isValidThreadProp]);

  useEffect(() => {
    // console.log(props.meetingData, 'props.meetingData')
    if (props.meetingData) {
      getCallData(props.meetingData);
    }
  }, [props.meetingData])

  const getCallData = async (meetingData: any) => {
    props.startCallLoader(false);
    const currentUserDetails: any = meetingData.currentUserDetails;
    if (currentUserDetails) {
      saveDisplayFirstNameToLocalStorage(currentUserDetails.firstName);
      saveDisplayLastNameToLocalStorage(currentUserDetails.lastName);
      saveDisplayEmailToLocalStorage(currentUserDetails.email);
      if (currentUserDetails.phone) {
        saveDisplayMobileToLocalStorage(currentUserDetails.phone ? currentUserDetails.phone : '');
      }
      saveDisplayTCToLocalStorage('true');
      const name: string = currentUserDetails.firstName + ' ' + currentUserDetails.lastName;
      const meetingDetails = meetingData.meetingDetails;
      // console.log(meetingDetails, 'meetingDetails')
      const urlParams = new URLSearchParams(window.location.search);
      const meetingId: any = urlParams.get('meetingId') || '';
      if (meetingDetails && meetingDetails.threadId) {
        sessionStorage.setItem('threadId', meetingDetails.threadId);
        sessionStorage.setItem('groupId', meetingDetails.groupId);
        sessionStorage.setItem('sfCaseNumber', meetingDetails.sfCaseNumber);
        sessionStorage.setItem('meetingStartTime', meetingDetails.meetingStartTime);
        sessionStorage.setItem('autoCallEndingAPIRunningTime', meetingDetails.autoCallEndingAPIRunningTime);
        var isValidThread: boolean = false;
        if (meetingDetails.threadId) {
          if (await isValidThreadProp(meetingDetails.threadId, meetingDetails.groupId)) {
            isValidThread = true;
          } else {
            isValidThread = false;
          }
        } else {
          isValidThread = false;
        }

        if (isValidThread === false && !getMeetingIdFromUrl()) {
          props.startCallHandler(isValidThread, name, 1, meetingDetails.groupId);
          saveDisplayIMOToLocalStorage('');
          saveDisplayHEXIDToLocalStorage('');
          saveDisplayMMSIToLocalStorage('');
        } else if (isValidThread === false && getMeetingIdFromUrl()) {
          props.startCallHandler(isValidThread, name, 2, meetingDetails.groupId);
          saveDisplayIMOToLocalStorage('');
          saveDisplayHEXIDToLocalStorage('');
          saveDisplayMMSIToLocalStorage('');
        } else if (isValidThread === true && !getMeetingIdFromUrl()) {
          props.startCallHandler(isValidThread, name, 3, meetingDetails.groupId);
          saveDisplayIMOToLocalStorage('');
          saveDisplayHEXIDToLocalStorage('');
          saveDisplayMMSIToLocalStorage('');
        } else if (isValidThread === true && getMeetingIdFromUrl()) {
          props.startCallHandler(isValidThread, name, 4, meetingDetails.groupId);
        }
        sessionStorage.setItem('meetingId', meetingId);
        window.history.pushState({}, '', window.location.href.split('?')[0]);
        window.history.pushState({}, '', window.location.href + '?page=call' + '&&meetingId=' + meetingId);
      } else {
        window.history.pushState({}, '', window.location.href.split('?')[0]);
        window.location.href = window.location.href + '?page=survey' + '&&meetingId=' + meetingId;
      }
    }
  }

  const getGroupIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('groupId');
  };

  const getThreadFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('threadId');
  }

  const getMeetingIdFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('meetingId');
  }

  const onChangeTC = (e: any) => {
    const checked = e.target.checked;
    setTermsandConditions(checked)
    if (checked) {
      setTCErrorMsg('');
    } else {
      setTCErrorMsg('Please agree to the terms of use');
    }
  }

  const onValueChange = (e: any) => {
    const name = e.target.name;
    const newValue = e.target.value;
    if (newValue === undefined) {
      return;
    }
    const errorMsg: any = validateField(name, newValue);
    if (name === 'displayFirstName') {
      setFNErrorMsg(errorMsg);
      setDisplayFirstName(newValue);
    } else if (name === 'displayLastName') {
      setLNErrorMsg(errorMsg);
      setDisplayLastName(newValue);
    } else if (name === 'displayEmail') {
      setEmailErrorMsg(errorMsg);
      setDisplayEmail(newValue);
    }
  };

  const handleOnChange = (value: any) => {
    // console.log(value)
    if (value.length >= 7 && value.length <= 20) {
      setMobileErrorMsg('');
    } else {
      setMobileErrorMsg('Please enter valid call back number.');
    }
    setDisplayMobile(value);
  }

  const validateField = (name: any, value: any) => {
    let errorMsg = null;
    switch (name) {
      case "displayFirstName":
        if (!value) errorMsg = "Please enter first name.";
        break;
      case "displayLastName":
        if (!value) errorMsg = "Please enter last name.";
        break;
      case "displayEmail":
        if (!value) errorMsg = "Please enter email.";
        else if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value))
          errorMsg = "Please enter valid email.";
        break;
      default:
        break;
    }
    return errorMsg;
  };

  useEffect(() => {
    if (props.pageLoader) {
      // props.reCall();
      reloadpage();
    }
  }, [props.pageLoader]);

  useEffect(() => {
    if (props.rejoin) {
      // props.reCall();
      reloadpage();
    }
  }, [props.rejoin]);

  useEffect(() => {
    if (getMeetingIdFromUrl() && defaultDisplayFirstName) {
      setLoader(false)
    }
  }, [getMeetingIdFromUrl()])

  const reloadpage = async () => {
    const meetingData = await getMeetingInfoData(getMeetingIdFromUrl());
    if (meetingData) {
      const data: any = meetingData.data;
      if (data) {
        const result: any = data.result;
        if (result) {
          sessionStorage.setItem('groupId', result.groupId);
          sessionStorage.setItem('threadId', result.threadId);
          sessionStorage.setItem('sfCaseNumber', result.sfCaseNumber);
          sessionStorage.setItem('meetingStartTime', result.meetingStartTime);
        }
      }
    }
  }

  const clickConnectNow = async () => {
    if (displayFirstName && displayLastName && displayEmail && displayMobile && termsandConditions) {
      let camEnabled = false
      let micEnabled = false
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
        if (stream.getVideoTracks().length > 0) {
          setCameraEnabled('true');
          camEnabled = true;
        } else {
          setCameraEnabled('false');
        }
        if (stream.getAudioTracks().length > 0) {
          setMicrophoneEnabled('true');
          micEnabled = true;
        } else {
          setMicrophoneEnabled('false');
        }
        stream.getTracks().forEach((track) => track.stop());
      } catch (error) {
        setCameraEnabled('false');
        setMicrophoneEnabled('false');
        console.log("Error while checking devices", error);
      }
      if (camEnabled || micEnabled) {
        if (displayEmail) {
          const errorMsg: any = validateField('displayEmail', displayEmail);
          setEmailErrorMsg(errorMsg);
        }
        if (displayMobile) {
          if (displayMobile.length >= 7 && displayMobile.length <= 20) {
            setMobileErrorMsg('Please enter valid call back number.');
          }
        }
        if (!errorFNMsg && !errorLNMsg && !errorEmailMsg && !errorMobileMsg && !errorTCMsg) {
          props.startCallLoader(false);
          saveDisplayFirstNameToLocalStorage(displayFirstName);
          saveDisplayLastNameToLocalStorage(displayLastName);
          saveDisplayEmailToLocalStorage(displayEmail);
          saveDisplayMobileToLocalStorage(displayMobile);
          saveDisplayTCToLocalStorage(termsandConditions ? 'true' : 'false');

          if (getMeetingIdFromUrl()) {
            const response: any = await createThreads(getMeetingIdFromUrl());
            // console.log(response, 'exist')
            if (response) {
              const responseData = response.data;
              if (responseData && responseData.success === true) {
                sessionStorage.setItem('userId', responseData.data.sfContactId);
                sessionStorage.setItem('sfContactId', responseData.data.sfContactId);
                props.startCall(true);
              } else {
                props.startCallLoader(true);
              }
            }
          } else {
            const response: any = await createThreads(null);
            // console.log(response, 'not exist')
            if (response) {
              const responseData = response.data;
              if (responseData && responseData.success === true) {
                window.history.pushState({}, '', window.location.href + '?page=call' + '&&meetingId=' + responseData.data.meetingId);
                sessionStorage.setItem('userId', responseData.data.sfContactId);
                sessionStorage.setItem('sfContactId', responseData.data.sfContactId);
                props.startCall(true);
              } else {
                props.startCallLoader(true);
              }
            }
          }
          //var meetingData: any = {};
          //if (getMeetingIdFromUrl()) {
          // meetingData = await getMeetingInfoData(getMeetingIdFromUrl());
          // if (meetingData) {
          //   const datas: any = meetingData.data;
          //   if (datas) {
          //     const results: any = datas.result;
          //     if (results) {
          //       const name: string = displayFirstName + ' ' + displayLastName;
          //       var isValidThread: boolean = false;
          //       if (results.threadId) {
          //         if (await isValidThreadProp(results.threadId, groupId)) {
          //           isValidThread = true;
          //         } else {
          //           isValidThread = false;
          //         }
          //       } else {
          //         isValidThread = false;
          //       }

          //       if (isValidThread === false && !getMeetingIdFromUrl()) {
          //         props.startCallHandler(isValidThread, name, 1, groupId);
          //         saveDisplayIMOToLocalStorage('');
          //         saveDisplayHEXIDToLocalStorage('');
          //         saveDisplayMMSIToLocalStorage('');
          //       } else if (isValidThread === false && getMeetingIdFromUrl()) {
          //         props.startCallHandler(isValidThread, name, 2, groupId);
          //         saveDisplayIMOToLocalStorage('');
          //         saveDisplayHEXIDToLocalStorage('');
          //         saveDisplayMMSIToLocalStorage('');
          //       } else if (isValidThread === true && !getMeetingIdFromUrl()) {
          //         props.startCallHandler(isValidThread, name, 3, groupId);
          //         saveDisplayIMOToLocalStorage('');
          //         saveDisplayHEXIDToLocalStorage('');
          //         saveDisplayMMSIToLocalStorage('');
          //       } else if (isValidThread === true && getMeetingIdFromUrl()) {
          //         props.startCallHandler(isValidThread, name, 4, groupId);
          //       }
          //       const userInfo: any = await createMeetingUserDetails(results.groupId, results.threadId);
          //       // console.log(userInfo, 'userInfo')
          //       if (userInfo) {
          //         const udata: any = userInfo.data;
          //         if (udata) {
          //           if (udata.meetingId) {
          //             sessionStorage.setItem('sfContactId', udata.sfContactId);
          //             sessionStorage.setItem('meetingId', udata.meetingId);
          //             window.history.pushState({}, '', window.location.href.split('?')[0]);
          //             window.history.pushState({}, '', window.location.href + '?page=call' + '&&meetingId=' + udata.meetingId);
          //           }
          //         }
          //       }
          //     }
          //   }
          // }
          //} else {
          // let threadId: any = await createThreadHelper();
          // // console.log(threadId, 'threadId', groupId)
          // sessionStorage.setItem('groupId', groupId);
          // sessionStorage.setItem('threadId', threadId);
          // const name: string = displayFirstName + ' ' + displayLastName;
          // var isValidThread: boolean = false;
          // if (threadId) {
          //   if (await isValidThreadProp(threadId, groupId)) {
          //     isValidThread = true;
          //   } else {
          //     isValidThread = false;
          //   }
          // } else {
          //   isValidThread = false;
          // }

          // if (isValidThread === false && !getMeetingIdFromUrl()) {
          //   props.startCallHandler(isValidThread, name, 1, groupId);
          //   saveDisplayIMOToLocalStorage('');
          //   saveDisplayHEXIDToLocalStorage('');
          //   saveDisplayMMSIToLocalStorage('');
          // } else if (isValidThread === false && getMeetingIdFromUrl()) {
          //   props.startCallHandler(isValidThread, name, 2, groupId);
          //   saveDisplayIMOToLocalStorage('');
          //   saveDisplayHEXIDToLocalStorage('');
          //   saveDisplayMMSIToLocalStorage('');
          // } else if (isValidThread === true && !getMeetingIdFromUrl()) {
          //   props.startCallHandler(isValidThread, name, 3, groupId);
          //   saveDisplayIMOToLocalStorage('');
          //   saveDisplayHEXIDToLocalStorage('');
          //   saveDisplayMMSIToLocalStorage('');
          // } else if (isValidThread === true && getMeetingIdFromUrl()) {
          //   props.startCallHandler(isValidThread, name, 4, groupId);
          // }
          // // console.log(groupId, threadId, props.serverCallId)
          // const response: any = await createThread(groupId, threadId, props.serverCallId);
          // if (response) {
          //   sessionStorage.setItem('sfContactId', response.data.sfContactId);
          //   sessionStorage.setItem('meetingId', response.data.meetingId);
          //   meetingData = await getMeetingInfoData(response.data.meetingId);
          //   window.history.pushState({}, '', window.location.href + '?page=call' + '&&meetingId=' + response.data.meetingId);
          // }
          //}

          // if (meetingData) {
          //   const data: any = meetingData.data;
          //   if (data) {
          //     const result: any = data.result;
          //     if (result) {
          //       sessionStorage.setItem('groupId', result.groupId);
          //       sessionStorage.setItem('threadId', result.threadId);
          //       sessionStorage.setItem('sfCaseNumber', result.sfCaseNumber);
          //       sessionStorage.setItem('meetingStartTime', result.meetingStartTime);
          //       sessionStorage.setItem('autoCallEndingAPIRunningTime', result.autoCallEndingAPIRunningTime);
          //     }
          //     // const name: string = displayFirstName + ' ' + displayLastName;
          //     // var isValidThread: boolean = false;
          //     // if (result.threadId) {
          //     //   if (await isValidThreadProp(result.threadId, groupId)) {
          //     //     isValidThread = true;
          //     //   } else {
          //     //     isValidThread = false;
          //     //   }
          //     // } else {
          //     //   isValidThread = false;
          //     // }

          //     // if (isValidThread === false && !getMeetingIdFromUrl()) {
          //     //   props.startCallHandler(isValidThread, name, 1, groupId);
          //     //   saveDisplayIMOToLocalStorage('');
          //     //   saveDisplayHEXIDToLocalStorage('');
          //     //   saveDisplayMMSIToLocalStorage('');
          //     // } else if (isValidThread === false && getMeetingIdFromUrl()) {
          //     //   props.startCallHandler(isValidThread, name, 2, groupId);
          //     //   saveDisplayIMOToLocalStorage('');
          //     //   saveDisplayHEXIDToLocalStorage('');
          //     //   saveDisplayMMSIToLocalStorage('');
          //     // } else if (isValidThread === true && !getMeetingIdFromUrl()) {
          //     //   props.startCallHandler(isValidThread, name, 3, groupId);
          //     //   saveDisplayIMOToLocalStorage('');
          //     //   saveDisplayHEXIDToLocalStorage('');
          //     //   saveDisplayMMSIToLocalStorage('');
          //     // } else if (isValidThread === true && getMeetingIdFromUrl()) {
          //     //   props.startCallHandler(isValidThread, name, 4, groupId);
          //     // }

          //   }
          // }
        }
      }
    } else {
      if (!displayFirstName) {
        setFNErrorMsg('Please enter first name.');
      }
      if (!displayLastName) {
        setLNErrorMsg('Please enter last name.');
      }
      if (!displayEmail) {
        setEmailErrorMsg('Please enter email.');
      }
      if (!displayMobile) {
        setMobileErrorMsg('Please enter call back number.');
      }
      if (!termsandConditions) {
        setTCErrorMsg('Please agree to the terms of use');
      }
    }
  }
  // console.log(cameraEnabled, microphoneEnabled)
  const clickSettingIcon = async () => {
    setSettingBox(!settingBox)
    // console.log(true, 'const clickConnectNow = async () => {')
  }
  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index: any) => {
    setValue(index);
  };

  const options = {
    enableTime: true,
    dateFormat: "d-m-Y h:i K",
    minuteIncrement: 30
  };

  const handleChanges = (event: any) => {
    setTimeZone(event.target.value);
  };

  const handleTZChange = (value: any) => {
    setTimeZoneValue(value);
    if (value) {
      setTimeZone(value.StandardName);
      setTZErrorMsg('');
    } else {
      setTimeZone('');
    }
  }

  const texthandleChanges = (event: any) => {
    setDescription(event.target.value);
  };

  const clickSchedule = async () => {
    if (timezone && dateTimeValue) {
      saveDisplayFirstNameToLocalStorage(displayFirstName || '');
      saveDisplayLastNameToLocalStorage(displayLastName || '');
      saveDisplayEmailToLocalStorage(displayEmail || '');
      saveDisplayMobileToLocalStorage(displayMobile || '');
      saveDisplayTCToLocalStorage(termsandConditions ? 'true' : 'false');
      // console.log(timezone, dateTimeValue[0], description);
      setScheduleStatus(true)
      let threadId: any = await createThreadHelper();
      sessionStorage.setItem('groupId', groupId);
      sessionStorage.setItem('threadId', threadId);
      const scheduledata: any = await createscheduleMeeting(dateTimeValue[0], timezone, description);
      //console.log(scheduledata, 'scheduledata')
      if (scheduledata) {
        //console.log(scheduledata.data, 'scheduledata.data');
        if (scheduledata.data) {
          const dutyOfficerDtls: any = scheduledata.data.dutyOfficerDetails;
          // var imgData = "data:image/jpeg;base64,"+''+dutyOfficerDtls.imageByte;
          setDutyOfficerDetails(dutyOfficerDtls);
        }
      }
      setScheduleStatus(false)
      setThankStatus(true)
      // setDateTimeValue('')
      // setTimeZone('EST')
      // setDescription('')
      // setMeetingType('connectNow');
    } else {
      if (!dateTimeValue) {
        setDTErrorMsg('Please select date time.');
      }
      if (!timezone) {
        setTZErrorMsg('Please select time zone');
      }
    }
  }

  // console.log(props.darkColor, props.lightColor)

  return (
    <Fragment>
      {loader &&
        <Fragment>
          <div className='landing_page_warpper'>
            <div className='landing_page_left'>
              <div className='top_landing_page_logo_top'><a href='https://www.liscr.com/'><img className='landinig_Liberianlogo' src={topLiberianlogo} /> </a></div>
              {/* <div>
              <img className='landing_page_slider' src={landingpage} style={{ width: '100%', height: '100%' }} />
              </div> */}
              <div className='landing_page_warpperview'></div>
              <div className='landing_page_lable_text'>
                <div className='landing_page_lable_text_1'>Duty Officer Video Call <br></br> (DOVC)</div>
                {/* <div className='landing_page_lable_text_2'>ALL FLAGS ARE NOT ALIKE</div> */}
              </div>
              <div className='Officer_list_warpper'><ul className='Officer_list'>
                <li className='Officer_list_lable_name'>Connect Now with one of our <br></br> Duty Officers available <strong className='Officer_lable_view_panel'>24/7</strong></li>
                <li className='Officer_list_lable_name'>Provides immediate <br></br> <strong className='Officer_lable_view_panel'> real-time solutions </strong></li>
                <li className='Officer_list_lable_name'>One click away from <br></br> high-quality <strong className='Officer_lable_view_panel'>live service</strong> </li>
              </ul></div>
            </div>
            <div className='landing_page_right'>
              <div className='landing_page_callout_box'>
                <div className='landing_page_logo_top'>Connect with Duty Officer</div>
                {(cameraEnabled && microphoneEnabled && cameraEnabled === "false" && microphoneEnabled === "false") ? (
                  <div className={classes.errormassagedevice}>
                    Your camera and microphone is turned off. Please enable and refresh the page to proceed.
                  </div>
                ) : (
                  <Fragment />
                )}

                <div className='landing_page_call_warpper'>
                  <div className="callout">
                    <div className="contentpanelwidgect">
                      <Box >
                        <AppBar position="static" style={{ background: '#438E8E', color: '#fff', display: 'none', boxShadow: '0px 2px 4px -1px rgb(0 0 0 / 0%), 0px 4px 5px 0px rgb(0 0 0 / 0%), 0px 1px 10px 0px rgb(0 0 0 / 0%)' }}>
                          <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="secondary"
                            TabIndicatorProps={{
                              style: {
                                display: "none",
                              },
                            }}
                          // // TabIndicatorProps={{ style: { background: '#fff' } }}
                          // inkBarStyle={{ background: '#fff' }}
                          // textColor="inherit"
                          // variant="fullWidth"
                          // aria-label="full width tabs example"
                          >
                            <Tab label="Call Duty Officer" className=
                              {value === 0 ? classes.active_tab : classes.default_tabStyle}  {...a11yProps(0)} />
                            <Tab className=
                              {value === 1 ? classes.active_tab : classes.default_tabStyle} label="Publications" {...a11yProps(1)} />
                            {/* <Tab className=
                        {value === 2 ? classes.active_tab : classes.default_tabStyle} label="Publications" {...a11yProps(2)} /> */}
                          </Tabs>
                        </AppBar>
                        <SwipeableViews
                          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                          index={value}
                          onChangeIndex={handleChangeIndex}
                        >
                          <TabPanel value={value} index={0}>
                            <Grid container spacing={2}>
                              {meetingType == 'connectNow' ? <Fragment>
                                <Grid className={classes.fristnamepanelm1} item xs={12} md={6}>
                                  <TextField
                                    id="standard-basic"
                                    label="First Name"
                                    name="displayFirstName"
                                    variant="standard"
                                    InputLabelProps={{ className: classes.labelStyles, style: { color: props.darkColor } }}
                                    InputProps={{ style: { fontSize: '24px', color: '#707070' } }}
                                    className={classes.fieldnamepanel1}
                                    required
                                    onChange={(e) => onValueChange(e)}
                                    defaultValue={displayFirstName}
                                    autoComplete='off'
                                  />
                                  {errorFNMsg &&
                                    <span className={classes.errormassagepanel}>{errorFNMsg}</span>
                                  }
                                </Grid>
                                <Grid className={classes.fristnamepanelm1} item xs={12} md={6}>
                                  <TextField
                                    id="standard-basic"
                                    label="Last Name"
                                    name="displayLastName"
                                    variant="standard"
                                    InputLabelProps={{ className: classes.labelStyles, style: { color: props.darkColor } }}
                                    InputProps={{ style: { fontSize: '24px', color: '#707070' } }}
                                    className={classes.field}
                                    required
                                    onChange={(e) => onValueChange(e)}
                                    defaultValue={displayLastName}
                                    autoComplete='off'
                                  />
                                  {errorLNMsg &&
                                    <span className={classes.errormassagepanel}>{errorLNMsg}</span>
                                  }
                                </Grid>
                                <Grid className={classes.emaifristnamepanelm1} item xs={12} md={12}>
                                  <TextField
                                    id="standard-basic"
                                    label="Email"
                                    name="displayEmail"
                                    variant="standard"
                                    InputLabelProps={{ className: classes.labelStyles, style: { color: props.darkColor } }}
                                    InputProps={{ style: { fontSize: '24px', color: '#707070' } }}
                                    className={classes.field}
                                    required
                                    onChange={(e) => onValueChange(e)}
                                    defaultValue={displayEmail}
                                    autoComplete='off'
                                  />
                                  {errorEmailMsg &&
                                    <span className={classes.errormassagepanel}>{errorEmailMsg}</span>
                                  }
                                </Grid>
                                <Grid className={classes.callbackfristnamepanelm1} item xs={12} md={12}>
                                  <MaterialUiPhoneNumber
                                    defaultCountry="us"
                                    variant="standard"
                                    label="Call Back Number"
                                    name="displayMobile"
                                    InputLabelProps={{ className: classes.labelStyles, style: { color: props.darkColor, fontFamily: "Segoe UI", fontWeight: 500 } }}
                                    InputProps={{ style: { fontSize: '20px', color: '#707070' } }}
                                    className={classes.field}
                                    required
                                    onChange={handleOnChange}
                                    value={displayMobile}
                                    disableAreaCodes={true}
                                    autoComplete='off'
                                  />
                                  {errorMobileMsg &&
                                    <span className={classes.errormassagepanel}>{errorMobileMsg}</span>
                                  }
                                </Grid>
                                <Grid className={classes.agreepanelm1} item xs={12} md={12}>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={<Checkbox color="primary" />}
                                      checked={termsandConditions}
                                      label={<span style={{ fontSize: '14px', color: '#707070', }}>I agree to the LISCR <a className={classes.termslink} target='_blank' href='https://www.liscr.com/sites/default/files/Terms_of_Use.pdf'>Terms of Use</a> and <a href='https://www.liscr.com/sites/default/files/07.21%20LISCR%20privacy%20notice.pdf' target='_blank' className={classes.termslink} >Privacy Policy</a></span>}
                                      onChange={(e) => onChangeTC(e)}
                                    />
                                    {errorTCMsg &&
                                      <span className={classes.errormassagepanel}>{errorTCMsg}</span>
                                    }
                                  </FormGroup>
                                </Grid>
                                <Grid className={classes.buttonsagreepanelm1} item xs={12} md={12}>
                                  <Button
                                    variant="contained"
                                    startIcon={<VideocamIcon style={{ fontSize: '28px' }} />}
                                    color="secondary"
                                    className={classes.buttonLoginColor + ' Connect_now_btn'}
                                    onClick={() => clickConnectNow()}
                                  >
                                    Connect Now
                                  </Button>
                                  {/* <Button variant="contained" startIcon={<DateRangeIcon />} color="secondary" className={classes.buttonLoginColor + ' Connect_later_btn'} onClick={() => { setMeetingType('sMeeting'); }}>
                                    Connect Later
                                  </Button>  */}
                                </Grid>
                              </Fragment> :
                                <Fragment>
                                  {scheduleStatus ? (
                                    <Spinner label={'shedule meeting in progress'} ariaLive="assertive" labelPosition="top" style={{ margin: 'auto' }} />
                                  ) : (
                                    <Fragment>
                                      {thankStatus ? (
                                        <Grid className={classes.buttonsagreepanelm1} item xs={12} md={12}>
                                          {/* <div style={{ textAlign: 'center', marginBottom: '12px' }}>
                                          <p>
                                            <Check style={{ border: '1px solid #a15959', borderRadius: '50%', padding: '10px', marginBottom: '-35px', color: '#a15959', fontSize: '40px' }} />
                                            {dateTimeValue &&
                                              <Fragment>
                                                <span style={{ fontWeight: '500', fontSize: '18px', color: 'rgb(112, 112, 112)', marginBottom: '10px', marginLeft: '10px' }}>{daysArray[new Date(dateTimeValue[0]).getDay()]}, {monthNames[new Date(dateTimeValue[0]).getMonth()]} {(new Date(dateTimeValue[0]).getDate())}</span><br />
                                                <span style={{ fontSize: '18px', color: 'rgb(112, 112, 112)', marginLeft: '10px' }}>
                                                  {new Date(dateTimeValue[0]).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</span>
                                              </Fragment>
                                            }
                                          </p>
                                        </div> */}

                                          {/* {(dateTimeValue && dutyOfficerDetails) &&
                                          <div style={{ fontSize: '18px', color: 'rgb(112, 112, 112)', marginBottom: '15px' }}>Your meeting has been scheduled at {daysArray[new Date(dateTimeValue[0]).getDay()]}, {monthNames[new Date(dateTimeValue[0]).getMonth()]} {(new Date(dateTimeValue[0]).getDate())} {new Date(dateTimeValue[0]).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })} <span style={{ fontSize: '18px', color: 'rgb(112, 112, 112)' }}> with {dutyOfficerDetails.jobTitle} ({dutyOfficerDetails.displayName}) </span></div>
                                        } */}

                                          {(dateTimeValue && dutyOfficerDetails) &&
                                            <Fragment>
                                              <div style={{ fontSize: '18px', color: 'rgb(112, 112, 112)', marginBottom: '15px' }}>Your meeting has been scheduled with </div>
                                              <span style={{ fontSize: '18px', color: 'rgb(112, 112, 112)', fontWeight: '500', marginBottom: '15px' }}>{dutyOfficerDetails.displayName} ({dutyOfficerDetails.jobTitle}) at {daysArray[new Date(dateTimeValue[0]).getDay()]}, {monthNames[new Date(dateTimeValue[0]).getMonth()]} {(new Date(dateTimeValue[0]).getDate())} {new Date(dateTimeValue[0]).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</span>
                                              {/* {dateTimeValue &&
                                              <div style={{ fontSize: '18px', color: 'rgb(112, 112, 112)', marginBottom: '15px' }}>at {daysArray[new Date(dateTimeValue[0]).getDay()]}, {monthNames[new Date(dateTimeValue[0]).getMonth()]} {(new Date(dateTimeValue[0]).getDate())} {new Date(dateTimeValue[0]).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}</div>
                                            } */}
                                            </Fragment>
                                          }

                                          <div style={{ textAlign: 'center' }}>
                                            {dutyOfficerDetails &&
                                              <img style={{
                                                display: 'inline-block',
                                                width: '150px',
                                                height: '150px',
                                                borderRadius: '50%',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'center center',
                                                backgroundSize: 'cover'
                                              }}
                                                src={dutyOfficerDetails.imageByte ? "data:image/jpeg;base64," + '' + dutyOfficerDetails.imageByte : 'http://ssl.gstatic.com/accounts/ui/avatar_2x.png'} alt="avatar"></img>
                                            }
                                          </div>

                                          <div style={{ fontSize: '18px', color: 'rgb(112, 112, 112)' }}>A link will be sent via email to meet your expert at the scheduled time.</div>

                                          <Button variant="contained" style={{ marginTop: '15px' }} startIcon={<CancelIcon />} color="secondary" className={classes.buttonLoginColor} onClick={() => { setMeetingType('connectNow'); }}>
                                            Close
                                          </Button>
                                        </Grid>
                                      ) : (
                                        <Fragment>
                                          <Grid className={classes.datetimezoneheader1} item xs={12} md={12}>
                                            <div className={classes.Selectlabelnamep1} style={{ fontWeight: '500', fontSize: '16px', color: props.darkColor }}>Select Date & Time</div>
                                            <Flatpickr
                                              placeholder="Select date & time"
                                              // ref={datepickerRef}
                                              options={options}
                                              value={dateTimeValue}
                                              className={classes.Selectdatedpanelm1}
                                              onChange={(date: any) => {
                                                // let selectedDate = date[0];
                                                // let currentDate = new Date();
                                                // let selectedDateWithCurrentTime = new Date(
                                                // 	selectedDate.setHours(
                                                // 		currentDate.getHours(),
                                                // 		currentDate.getMinutes(),
                                                // 		currentDate.getSeconds()
                                                // 	)
                                                // );
                                                // console.log(
                                                // 	"selectedDateWithCurrentTime",
                                                // 	selectedDateWithCurrentTime
                                                // );
                                                setDateTimeValue(date);
                                                if (date) {
                                                  setDTErrorMsg('');
                                                }
                                              }}
                                            />
                                            {errorDTMsg &&
                                              <span className={classes.errormassagepanel}>{errorDTMsg}</span>
                                            }
                                          </Grid>
                                          <Grid
                                            // className={classes.timezoneheader1} 
                                            item xs={12} md={12}>
                                            {/* <FormControl
                                            variant="standard"
                                            // sx={{ m: 1, minWidth: 120 }} 
                                            className={classes.field}
                                          >
                                            <InputLabel id="demo-simple-select-standard-label" className={classes.Selectlabelnamep1} style={{ fontWeight: '500', fontSize: '20px', color: props.darkColor }}>Time Zone</InputLabel>
                                            <Select className={classes.gmttimevalue1} style={{ marginTop: '23px' }}
                                              labelId="demo-simple-select-standard-label"
                                              id="demo-simple-select-standard"
                                              value={timezone}
                                              onChange={handleChanges}
                                              label="Time Zone"
                                            // InputLabelProps={{ style: { fontSize: '14px', color: '#0077E6' } }}
                                            // InputProps={{ style: { fontSize: '18px', color: '#707070' } }}
                                            >
                                              <MenuItem value={'EST'}>(GMT-05:00) Eastern Time USA & Canada </MenuItem>
                                              <MenuItem value={'EET'}>GMT+02:00 - Africa/Cairo - Cairo</MenuItem>
                                              <MenuItem value={'CST'}>(GMT-06:00) Central Time (US and Canada)</MenuItem>
                                            </Select>
                                          </FormControl> */}
                                            <Autocomplete
                                              {...defaultProps}
                                              id="auto-complete"
                                              autoComplete
                                              includeInputInList
                                              renderInput={(params) => (
                                                <TextFields {...params}
                                                  label="Time Zone"
                                                  InputLabelProps={{ style: { fontWeight: '500', fontSize: '18px', color: props.darkColor, fontFamily: 'Segoe UI' } }}
                                                  variant="standard" />
                                              )}
                                              onChange={(event: any, newValue: any) => {
                                                handleTZChange(newValue)
                                              }}
                                              value={timezonevalue}
                                            />
                                            {errorTZMsg &&
                                              <span className={classes.errormassagepanel}>{errorTZMsg}</span>
                                            }
                                          </Grid>
                                          <Grid className={classes.timezoneheader1} item xs={12} md={12}>
                                            {/* <TextField id="standard-basic" label="Email" className={classes.field} multiline rows={5} /> */}
                                            <div className={classes.Selectlabelnamep1} style={{ fontWeight: '500', fontSize: '16px', color: props.darkColor }}> Description (Optional)</div>
                                            <TextareaAutosize
                                              aria-label="minimum height"
                                              minRows={4}
                                              // placeholder="Please Enter Description"
                                              // style={{ width: 200 }}
                                              className={classes.DescriptionSelecttext}
                                              autoComplete='off'
                                              onChange={texthandleChanges}
                                            />
                                          </Grid>
                                          <Grid className={classes.buttonsagreepanelm1} item xs={12} md={12}>
                                            <Button variant="contained" startIcon={<DateRangeIcon />} color="secondary" className={classes.buttonLoginColor} onClick={() => clickSchedule()}>
                                              Schedule
                                            </Button>
                                            <Button variant="contained" style={{ marginLeft: '20px' }} startIcon={<CancelIcon />} color="secondary" className={classes.buttonLoginColor} onClick={() => { setMeetingType('connectNow'); }}>
                                              Reset
                                            </Button>
                                          </Grid>
                                        </Fragment>
                                      )}
                                    </Fragment>
                                  )}
                                </Fragment>
                              }
                            </Grid>

                            {/* <div className='Connecttextheader1'>Connect Live or On-demand with the Duty Officer</div> */}

                          </TabPanel>
                          <TabPanel value={value} index={1}>
                            ----
                          </TabPanel>
                          {/* <TabPanel value={value} index={2}>
                      ----
                    </TabPanel> */}
                        </SwipeableViews>
                      </Box>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </Fragment>
      }
    </Fragment>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(HomeScreen);
